import Card from "~/scripts/services/model/card";

// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevSmartFieldController {
	/* @ngInject */
	constructor() {
		// this.data = [
		// 	{
		// 		kid: 'K_NODE;PERS_OLIVIER',
		// 		name: 'Olivier BERAUD',
		// 	},
		// ];

		this.myForm = {};
		this.readOnly = false;
		this.settings = {
			order:       'K_NODE;FIRSTNAME',
			placeholder: 'My placeholder',
			sm_qrcode:   false,
			suggest:     false,
		};
		this.validate = {
			card: new Card('0-1'),
		};
	}
}
